// extracted by mini-css-extract-plugin
module.exports =  {"btn":"L5V2z8L","icon":"C7DmiPz","open":"zEXr84v"};